<template>
    <div>
        <v-server-table
            :url="apiUrl"
            :columns="columns"
            :options="options"
            class="trigger organisation-table"
            ref="table"
        >
            <template slot="relation" slot-scope="{ row }">
                <router-link :to="{
                    name: 'admin.relations.view',
                    params: {
                        'id': row.milestone_progress.trajectory_enrolment.relation.id,
                    }
                }">{{ row.milestone_progress.trajectory_enrolment.relation.full_name }}</router-link>
            </template>
            <template slot="trajectory_name" slot-scope="{ row }">
                <link-if
                    :if="false && $can('view-trajectory-enrolments')"
                    :to="{
                        name: 'admin.relations.trajectory-enrolments.view',
                        params: {
                            'relationId': row.milestone_progress.trajectory_enrolment.relation.id,
                            'trajectoryEnrolmentId': row.milestone_progress.trajectory_enrolment.id,
                        }
                    }"
                >{{ row.milestone_progress.trajectory_enrolment.trajectory.name }}</link-if>
            </template>
            <template slot="report" slot-scope="{ row }">
                <div class="open-report" @click="openReportModal(row.id)">
                    <i class="fa fa-eye"></i> <span>{{ $getIfExists(row, 'action_document_version.action_document.name') }}</span>
                </div>
            </template>
            <template slot="download" slot-scope="{ row }">
                <div class="open-report" @click="downloadReport(row.id, $getIfExists(row, 'action_document_version.action_document.name', 'download') + '.pdf')">
                    <i class="fa fa-download"></i> <span>{{ $getIfExists(row, 'action_document_version.action_document.name') }}</span>
                </div>
            </template>
            <template slot="created_at" slot-scope="{ row }">
                {{ row.updated_at | date }}
            </template>
        </v-server-table>
        <portal to="modals" v-if="showReport">
            <b-modal
                v-model="showReport"
                :hideFooter="true"
                :title="uLang('app.report')"
                size="lg"
            >
                <iframe
                    :src="route('export.actionprogress.filled', {
                        actionProgress: clickedReportId,
                        downloadType: 'stream',
                    })"
                    frameborder="0"
                    style="width: 100%; height: 60vh"
                ></iframe>
            </b-modal>
        </portal>
    </div>
</template>

<script>
    import { TableMixin } from '~/mixins'

    export default {
        name: 'generated-reports-table',
        mixins: [ TableMixin ],
        data () {
            return {
                showReport: false,
                clickedReportId: null,
                apiUrl: route('generated-reports.table'),
                columns: [
                    'relation',
                    'trajectory_name',
                    'report',
                    'download',
                    'created_at',
                ],
                filterable: ['relation'],
                options: {
                    headings: {
                        relation: this.uLang('app.employee'),
                        trajectory_name: this.uLang('app.trajectory_name'),
                        report: this.uLang('app.check_report'),
                        created_at: this.uLang('app.created_at'),
                        download: this.uLang('app.download_report'),
                    },
                },
            }
        },

        methods: {
            openReportModal(reportId) {
                this.clickedReportId = reportId;
                this.showReport = true
            },

            downloadReport(reportId, fileName) {
                this.downloadFile(route('export.actionprogress.filled', {
                    actionProgress: reportId,
                    downloadType: 'generate',
                }), fileName)
            },

            downloadFile(href, filename = null) {
                var anchor = document.createElement('a');
                anchor.href = href;
                anchor.download = href;
                if (filename !== null) {
                    anchor.download = filename
                }
                document.body.appendChild(anchor);
                anchor.click();
                anchor.remove()
            }
        },
    }
</script>

<style lang="scss">
    .open-report {
        cursor: pointer;
        display: inline-block;

        span {
            color: #c10f6d;
        }
    }
</style>
